import { Action } from '@ngrx/store';
import { DerivacionData } from '../models/store.model';


export const SETDERIVACIONDATA = '[DerivacionData] Set Data';
export const UNSETDERIVACIONDATA = '[DerivacionData] Unset Data';

export class SetDerivacionData implements Action {
    readonly type = SETDERIVACIONDATA;
    constructor(public derivacion: DerivacionData) { }
}

export class UnsetDerivacionData implements Action {
    readonly type = UNSETDERIVACIONDATA;
}

export type DerivacionDataActions =
    | SetDerivacionData
    | UnsetDerivacionData;
